import React from 'react';
import { ThemeProvider } from '@ui';
import { AlertProvider } from './alert';

export const FeedbackProvider: React.FC = (props) => {
  return (
    <ThemeProvider>
      <AlertProvider {...props} />
    </ThemeProvider>
  );
};
